<template>
    <v-card height="100%" class='mt-12'>
    <v-navigation-drawer
      absolute
      width="310"
      permanent
      left
    >
      <v-list-item>
        <v-list-item-content>
          <!-- <v-list-item-title class="title" >
            Метрика портала
          </v-list-item-title> -->
          <v-list-item-subtitle>
            Разделы метрики
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="item in menus"
          :key="item.slug"
          
          @click='choose_stat(item.slug)'
        >
        
          <v-list-item-icon>
            <v-icon :color='$mainColor'>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-row>
        <v-col cols=3>
        </v-col>
        <v-col>
            <template v-if="current_menu==='export_emails'" >
                <v-card class="pl-4">
                    <v-row>
                        <v-col>
                            <div class="input-container input-name modal-mul-select">
                                <v-select
                                v-model="selected_export_type"
                                :items="type_list"
                                item-text="descr"
                                item-value="type"
                                outlined
                                chips
                                required
                                ></v-select>
                            </div>
                        </v-col>
                        <v-col class="pt-7">
                            <v-btn :color="$mainColor" label dark @click='get_emails()' :disabled="selected_export_type == 'none'" >
                                Выгрузить
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-card width="95%">
                            <p class="ma-0">В текст письма обязательно добавляйте эту ссылку, чтобы пользователи имели возможность отписаться:</p>
                            <b>&lt;a href="https://proposal.nrcki.ru/unsubscribe" target="_blank"&gt;Отписаться от&nbsp;рассылки&lt;/a&gt;</b>
                            <p>{{ emails_text }}</p>
                        </v-card>
                    </v-row>
                </v-card>

            </template>        
            <!-- <template v-if="current_menu==='general_stat'" >
                <general-stat class="my-library-theme" /> 
            </template> -->
            <template v-if="current_menu==='oper_magazine'">
                <oper-stat/>
            </template>
            <template v-if="current_menu==='calendar'">
                <!-- <calendar-page/> -->
            </template>
        </v-col>
    </v-row>
  </v-card>
    
    
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import Chart from 'chart.js'
import WidgetRenderFile from '../components/widgets/render-file'
import OperStat from '../components/dashboard/operative.vue'


export default {
    name: 'DasBoardPage',
    components: {
        WidgetRenderFile,
        OperStat,
    },

    data() {
        return {
            current_menu: 'export_emails',
            menus: [
                {name:'Выгрузка email-ов',slug:'export_emails',disabled:false, icon:'mdi-email-multiple'},
                {name:'Оперативные журналы',slug: 'oper_magazine' ,disabled:true, icon:'mdi-clock-fast'},
                // {name:'Календарь',slug: 'calendar' ,disabled:false, icon:'mdi-calendar-text'},
                
            ],
            statusList: [
                {slug:'archived', name: this.$t('ModeratorList.archived')},
                {slug:'draft', name: this.$t('ModeratorList.applications_still_being_formed')}, 
                {slug:'created', name: this.$t('ModeratorList.incoming_requests')}, 
                {slug:'expertise', name: this.$t('ModeratorList.on_examination')}, 
                {slug:'statement', name: this.$t('ModeratorList.expert_advice')}, 
                {slug:'approve', name: this.$t('ModeratorList.adopted')}, 
                {slug:'modification', name: this.$t('ModeratorList.on_completion')}, 
                {slug:'scheduled', name: this.$t('ModeratorList.experiment_planned')}, 
                {slug:'need_report', name: this.$t('ModeratorList.awaiting_report')}, 
                {slug:'done', name: this.$t('ModeratorList.completed')}, 
                {slug:'publication', name: this.$t('ModeratorList.there_publication')}, 
                {slug:'deleted', name: this.$t('ModeratorList.deleted')}, 
                {slug:'reject', name: this.$t('ModeratorList.rejected')}
            ],
            headers: [
                {
                    text: this.$t('name'),
                    value: 'name'
                },
                {
                    text: this.$t('accepted_applications'),
                    value: 'approve'
                },
                {
                    text: this.$t('Experiment'),
                    value: 'expertise'
                }
            ],

            listRequestStation: [],
            listRequestStatus: null,
            labelsStatus: [],
            countRequestStatus: [],

            emails_text: '',
            type_list: [
                {type: 'none', descr: 'Выберите тип выгрузки'},
                {type: 'all_active', descr: 'Все активные пользователи'},
                {type: 'rsini_active_users_24', descr: 'Участники ФСНЭ-24'},
                {type: 'rsini_active_users_25', descr: 'Участники ФСНЭ-25'},
            ],
            selected_export_type: 'none',
        }
    },

    watch:{
        selected_export_type(val) {
            this.emails_text = ''
        }
    },

    methods: {
        ...mapActions([
            'LOAD_EMAIL_LIST',
        ]),
        ...mapMutations([
            'UPDATE_OVERLAY',
        ]),

                
        get_emails(){
            this.UPDATE_OVERLAY(true)

            if(this.selected_export_type == 'none'){
                return
            }

            this.LOAD_EMAIL_LIST({type: this.selected_export_type})
                .then((data) => {
                    console.log(data)
                    if(data.error){
                        this.$messageHelper(data.error, 'error', 3000);
                    }
                    else{
                        this.emails_text = data.emails
                    }
                    this.UPDATE_OVERLAY(false)
                })
                .catch((e) => {
                    this.UPDATE_OVERLAY(false)
                });
        },

        choose_stat(slug){
            this.current_menu = slug
        },

        createdDiagram() {
            var ctx = document.querySelector('#myChart').getContext('2d');
            var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: this.labelsStatus,
                    datasets: [{
                        label: '# of Votes',
                        data: this.countRequestStatus,
                        backgroundColor: [
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor
                        ],
                        borderColor: [
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor,
                            this.$mainColor
                        ],
                        borderWidth: 1
                    }]
                },
            });
        }
    },
}
</script>

<style  lang="scss" >
    @import '../components/Admin/sass/light-bootstrap-dashboard.scss';
</style>

<style >
        @import '../components/Admin/css/light-dashboard.css';
        
</style>

<style scoped>
.chart {
    padding-top: 60px;
}
.chart__diagram-bar {
    max-width: 800px;
    width: 100%;
    min-height: 1px;
    max-height: 800px;
}
.chart__statistics {
    max-width: 750px;
    width: 100%;
}
.dashboard-table {
    padding: 50px 20px 20px 20px;
    width: 100%;
}
</style>